import SectionCities from '../../../../containers/LandingPage/SectionCities';
import { withBaseComponent } from '../../hoc/withBaseComponent';

const StoryblokCitiesWomoPreset = () => {
  return <SectionCities />;
};

export default withBaseComponent(StoryblokCitiesWomoPreset);
